// 最后生成时间：10/23/2018 14:16:33
import { GetCurrentLoginInformationsOutput } from './GetCurrentLoginInformationsOutput';
import { UpdateUserSignInTokenOutput } from './UpdateUserSignInTokenOutput';
import { throwException } from './Utilities';
var SessionServiceProxy = /** @class */ (function () {
    function SessionServiceProxy(baseUrl) {
        this.beforeSend = undefined;
        this.jsonParseReviver = undefined;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.getCurrentLoginInformations = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getCurrentLoginInformationsWithCallbacks(function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    SessionServiceProxy.prototype.getCurrentLoginInformationsWithCallbacks = function (onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");
        abp.ajax.request({
            url: url_,
            method: "get",
            headers: {
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processGetCurrentLoginInformationsWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processGetCurrentLoginInformationsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    SessionServiceProxy.prototype.processGetCurrentLoginInformationsWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processGetCurrentLoginInformations(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    SessionServiceProxy.prototype.processGetCurrentLoginInformations = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.updateUserSignInToken = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.updateUserSignInTokenWithCallbacks(function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    SessionServiceProxy.prototype.updateUserSignInTokenWithCallbacks = function (onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");
        abp.ajax.request({
            url: url_,
            method: "put",
            headers: {
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processUpdateUserSignInTokenWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processUpdateUserSignInTokenWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    SessionServiceProxy.prototype.processUpdateUserSignInTokenWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processUpdateUserSignInToken(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    SessionServiceProxy.prototype.processUpdateUserSignInToken = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    return SessionServiceProxy;
}());
export { SessionServiceProxy };
